import { Toast } from "antd-mobile"
import useAPI from "../../hooks/common/useAPI"
import useSDK from "../../hooks/data/useSDK"
import { ReactComponent as SVGKeFu } from "../../svg/kefu.svg"
export default () => {

    const { request } = useAPI()
    const { getAppid } = useSDK()
    const goToKeFu = async () => {

        let rs = await request("/app/config", { app_id: getAppid() })
        if (rs?.result === true) {
            if (!rs?.data?.kefu_url) {
                return Toast.show('獲取配置失敗')
            }
            window.location.href = rs?.data?.kefu_url;

        } else {
            Toast.show(rs?.message)
        }

    }

    return <div onClick={goToKeFu} style={{
        position: 'fixed', left: "0rem",background:"rgba(126, 224, 184, 0.5)",opacity:"0.8",
        bottom: "0.5rem", borderRadius: "1rem", overflow: "hidden", display: "flex", flexDirection: 'column', justifyContent: "center", alignItems: 'center'
    }}>
        {/* <SVGKeFu style={{ width: "0.46rem", height: "0.46rem" }} /> */}
        <img src={require('../../icons/kefu.png')} style={{width:"0.5rem", marginRight:"-0rem"}} />
        {/* <div>联系客服</div> */}
    </div>
}